import React, {Component} from 'react';
import './App.css';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlList: ['mhg', 'gxj', 'mqg', 'qwg', 'qmsht', 'mqgy', 'gzj'],
      urlNow: window.location.hash.match(/^#(mhg|gxj|mqgy|qwg|qmsht|mqg|gzj)/)[1],
      mhg: {
        tit: [
          "横店影视城梦幻谷简介",
          "横店影视城梦幻谷景区包括梦文化村、水世界、儿童梦工厂、江南水乡、海豚湾五大区域，占地484亩，是一个以火山爆发、暴雨山洪等各种自然现象及自然风貌展示为主，配以各种游乐设施和演艺活动等内容的大型夜间影视体验主题公园。",
          "“梦文化村”主要包括今夜星河广场、金色胡杨、蓝月亮门、了了城堡、亚马快车、爪哇欢跳、阿周那锤、雪域飞鹰、吉祥转马、斯曼浪桥、喜马天轮等游乐项目。",
          "“水世界”以地中海地区的地理风貌为原型，以中东地区的文化背景和世界名著《一千零一夜》的故事为主题。建有一千零一夜戏水区、地中海海浪区、土耳其古城区、飓风湾探险区等，拥有亚丁风暴、幼发拉梯、辛巴飞毯、波塞冬碗、多哈滑道和爱琴蓝海等数十项大型水上游乐设备和游乐区域.",
          "“儿童梦工厂”是一个以“梦幻、卡通、亲情”为主题的浙中首个高科技室内儿童乐园，包含宝宝水母、旋转宝贝、摩尔跳鼠、挖沙寻宝、飞屋环游、水果战士等游乐项目以及儿童励志音乐剧《小鸟加油》和4D森林剧场。",
          "“江南水乡”集江浙水乡之精华而营造，生动地展示了清末民初时期江南水乡的民生百态和万种风情，是影视剧组的取景拍摄区。",
          " “海豚湾”坐落于梦幻谷景区东边，东临梦幻谷停车场，南接梦幻谷《暴雨山洪》演出剧场，北接贵宾楼。占地面积为24000平方米，主要内容有海洋动物展示区、梦幻海豚表演场、海豚互动区。视觉的盛宴——《海洋剧场》，在可满足3200人观演需求的海洋剧场内，结合LED大屏的实时显示海豚表演。海豚以可爱的外形，滑稽的姿态，高超的海豚音，加上与驯养师的完美搭配，带给观众无尽的惊喜和视觉上的享受。",
          "亚洲超一流室外大型演艺——《梦幻太极》是横店影视城的标志性演出，全球最大的火山实景演出，亚洲超一流的室外大型演出，中国十大最具国际影响力的旅游演出。第八版《梦幻太极》于2014年7月正式上演，新版节目对水陆空三级舞台进行全面升级，配上亚洲顶级的室外灯光秀、梦幻色彩的演出服装，为观众呈现无与伦比的震撼演出。",
          "国内首家灾难实景演绎——《暴雨山洪》，是一个集声、光、电、影视特技、舞蹈艺术为一体，艺术性、观赏性、科普性与体验性于一身的大型实景“灾难性”演艺项目。整场节目演出时间约半个小时，节目高潮，580吨的洪水从山顶倾泄而下，暴雨如注、山洪如兽的灾难场景，气势磅礴、险象环生！重建家园后踏歌起舞的嬉水狂欢，使您身在其中，又仿在梦境。"
        ],
        img: [
          './images/mhg/1.jpg',
          './images/mhg/2.jpg',
          './images/mhg/3.jpg',
          './images/mhg/4.jpg',
          './images/mhg/5.jpg',
          './images/mhg/6.jpg',
          './images/mhg/7.jpg',
          './images/mhg/8.jpg',
          './images/mhg/9.jpg',
          './images/mhg/10.jpg',
          './images/mhg/11.jpg',
          './images/mhg/12.jpg',
          './images/mhg/13.jpg',
          './images/mhg/14.jpg',
          './images/mhg/15.jpg',
        ]
      },
      gxj: {
        tit: [
          '横店影视城广州街香港街夜景',
          ' 香港街夜景坐落于横店影视城广州街香港街景区内香港街区维多利亚港区域，德辅道、毕打街、皇后大道、干诺道、遮打街环线打造极具19世纪老香港风情的建筑群，并融入影视场景、美食小吃、娱乐酒吧、潮流商业、演艺秀、小品景观等。 ',
          '一脚踏入港城区，仿佛瞬间身临“老香港”。',
          '穿越，不仅仅是扑面而来的一栋栋19世纪香港风情的主题建筑，而是真真切切置身于栩栩如生的电影版街景中—— 入夜时分，整个港城区被五颜六色的霓虹灯照亮，成了一座影视主题的不夜城。 ',
          '抛开所有，一头扎进港式电影中独有的繁华夜景里。每个转角和店铺，都是一个新的影视体验惊喜。',
          '《麻雀》剧中的隐藏场景“陈深理发店”熙熙攘攘，梦想成为一名剃头匠的“陈深”在里面为爱美的人们忙碌着；',
          '《倾城之恋》中的“浅水湾饭店”底下开设了一家“爱情邮局”，心里倘若装了TA，别忘用最饱含感情的形式互诉衷情； ',
          '倘若你偏爱内敛的安静，《一触即发》中地下工作者主要联络点“荣华书屋”，则提供了各种书籍供人免费观看，也可购买。',
          '买买买，也是来到老香港的重要主题，不妨到《旗袍》主题楼下的“冉云旗袍店”置办一套惊艳港城的旗袍； ',
          '隔壁的“华东影楼”是《伪装者》秘密情报站所在，在上家买的旗袍何不到这影楼来一套“旧香港”风情的靓人写真？还能拍一部唯美的微电影哦。',
          '一切都按你心中的“电影剧本”来，这里的夜生活丰富到住上一周都不会腻。 ',
          '在黄包车夫的避让声中，放松心情穿过各色江湖人物出没的街道，来到夜晚的下塌处广香街影视主题酒店。如果你爱胡歌、王凯、靳东这俊俏的明家三兄弟，就住在《伪装者》影视主题客房；如果你心中的男神是李易峰，千万不能错过《麻雀》主题客房；又如果你沉迷《老九门》中的“启月”CP，干脆直接拎包入住新月饭店的CP发糖现场——尹新月闺房。',

        ],
        img: [
          './images/gxj/1.jpg',
          './images/gxj/2.jpg',
          './images/gxj/3.jpg',
          './images/gxj/4.jpg',
          './images/gxj/5.jpg',
          './images/gxj/6.jpg',
          './images/gxj/7.jpg',
          './images/gxj/8.jpg',
          './images/gxj/9.jpg',
          './images/gxj/10.jpg',

        ],
      },
      mqg: {
        tit: [
          '横店影视城梦泉谷温泉度假区'
        ],
        img: [
          './images/mqg/1.jpg',
          './images/mqg/2.jpg',
          './images/mqg/3.jpg',
          './images/mqg/4.jpg',
          './images/mqg/5.jpg',
          './images/mqg/6.jpg',
          './images/mqg/7.jpg',
          './images/mqg/8.jpg',
        ]
      },
      qwg: {
        tit: [
          '横店影视城秦王宫简介',
          '秦王宫景区是1997年为著名导演陈凯歌拍摄历史巨片《荆柯刺秦王》而建，也是《英雄》、《功夫之王》等大片的诞生地。设计师们花费了四年心血设计出一幅宏伟的秦王宫蓝图，而秦王宫景区的原型就是秦王朝最主要的宫殿——咸阳宫。',
          '秦王宫景区仿建大殿及各类侧殿、楼阙、宫门共27座，城墙周长约2.5公里，最高处达18米。以规模巨大、形体复杂、布局严谨而著称。有雄伟壮观的各类宫 殿，五步一楼，十步一阁；廊腰缦回，檐牙高啄，各抱地势，钩心斗角。巍巍城墙与王宫大殿交相辉映。主宫“四海归一殿” 威严矗立，高耸挺拔，淋漓尽致地表现出秦始皇并吞六国，一统天下的磅礴恢宏气势。黄尘古道，金戈铁马，燕赵建筑，秦汉文化，在秦王宫得以真实再现。 ',
          '秦王宫最精彩的演艺秀是《龙帝惊临》——4D乘骑体验。《龙帝惊临》项目以在景区拍摄的好莱坞电影《木乃伊3之龙帝之墓》的精彩剧情为背景，每人分发一副4D眼镜，8人一组乘坐一辆轨道车，缓缓进入场景中，场景中有多块屏幕，通过轨道车运行感觉到上升下降，切换不同剧情，让人身临其境，惊险刺激不容错过。',
          '影视特技真人秀——演艺秀《英雄比剑》古琴雨声顺着棋馆青黑的屋檐流淌，英雄在空中上下翻飞，状如舞蹈，比剑亦是一场生死角逐。英雄与美人，理想与抱负，都在残剑与无名洒脱的飞身打斗中流传。亲临大片原产地，揭开心底重重谜团，此刻，让英雄重新唤醒我们心底的武侠梦！ ',
          '演艺秀《始皇登基》在巍峨壮阔的四海归一殿前，在傩舞的辟邪与乐舞的庆贺下，祭告寡人受命于天、承制于祖、登基为帝、大赦天下。 ',
          '演艺秀《梦回秦汉》从参与者的角度看待因匈奴问题而引起的秦始皇、汉武帝两帝之间的不同认知，解密其未能沟通的遗憾。两帝各执一词、各抒己见。3D电影般真切的呈现在我们眼前，让我们能够魔幻般的看到秦皇汉武面对面的交流，还能体验到剧中人与游客捉迷藏的妙趣。许多瞬间变换的梦幻感觉，给人带来无尽的思考与遐想，更让人享受到穿越时空梦幻般的快乐！ ',
          '秦王宫景区也因为浓烈的历史氛围，助《荆轲刺秦王》获得了1999年戛纳电影节的最佳技术奖。同时它也吸引了众多的大片来这里拍摄，可以说秦王宫景区是影 视大片和历史正剧的摇篮。同时也吸引了包括《英雄》、《汉武大地》、《寻秦记》、《功夫之王》、《画皮》、《木乃伊：龙帝之墓》、《美人心计》等在内的众 多的影视大片来这里取景拍摄。 ',
          '在这里，曾拍摄影视作品：《寻秦记》、《风云》、《汉武大帝》、《无极》、《大汉天子》、《倾世皇妃》、《贞观长歌》、《木乃伊：龙帝之墓》、《美人心 计》、《功夫之王》、《新三国演义》、《画皮》、《鸿门宴》、《四大名捕》、《琅琊榜》、《美人天下》、《陆贞传奇》、《倾世皇妃》、《古剑奇谭》、《贤 后卫子夫》等500余部。  ',
        ],
        img: [
          './images/qwg/1.jpg',
          './images/qwg/2.jpg',
          './images/qwg/3.jpg',
          './images/qwg/4.jpg',
          './images/qwg/5.jpg',
          './images/qwg/6.jpg',
          './images/qwg/7.jpg',
          './images/qwg/8.jpg',
          './images/qwg/9.jpg',
          './images/qwg/10.jpg',
          './images/qwg/11.jpg',
          './images/qwg/12.jpg',
          './images/qwg/13.jpg',
          './images/qwg/14.jpg',
          './images/qwg/15.jpg',
        ]

      },
      qmsht: {
        tit: [
          '横店影视城清明上河图简介',
          '清明上河图景区是根据北宋著名画家张择端的巨作《清明上河图》为蓝本，结合北宋时期的社会背景、民俗、民风及宋时的古建特色，按影视拍摄的需要建造而成的 影视基地。 清明上河图景区占地面积600余亩，建有房屋120多幢，桥梁6座，码头9个，船只6艘，牌坊14座。景区分为外城和里城，城中有“汴河”蜿蜒，形成了城 外有城，河内有河的独特格局。 ',
          '风光旖旎独特，细细品味，妙趣横生。画舫美丽精致、牌坊高耸林立、花卉争奇斗艳。登上巍峨的景门城楼，近可俯瞰基地全貌，远可眺望整个横店城。 ',
          '汴河蜿蜒，河水清澈，波光粼粼。河岸柳树成荫，河里鱼儿成群、历历可见，走上虹桥，好似踩虹上天，真是心旷神怡。无论是开封府还是蔡童相府，一处处建筑，四角高挑， 飞阁流檐，色彩浓丽，更有亭台楼阁、轩廊水榭装点其中，城内店铺林立，楼宇鳞次栉比，气派的樊楼，别致的水门，精美的绣阁、府第，再现了千年前北宋东京汴 河漕运的繁华景象及市井生活、民俗风情，真正是“一朝步入画中，仿佛梦回千年”。 ',
          '《汴梁一梦》是由来自河北省吴桥杂技团的专业演员现场演出的大型古彩戏法。它再现了张择端在创作清明上河图时的所见、所闻、所感。在经历了梦境与现实之后，最终创下千古名画——《清明上河图》。整场节目融合景区特色，表现昔日大宋汴梁古都的繁荣及民生百态，以现代人独特的眼光看待宋朝的民间演艺。',
          '《游龙戏凤》是一台全息环幕电影演艺秀，故事源自宋徽宗与李师师之间的爱情故事。该节目的表演区位360度全方位环绕式大厅，节目通过全息投影，透视幕，舞美特效，真人表演于一体，引领观众进入杏花楼，竹林，战场等多个立体场景画面中，让人感觉如临其境，陶醉其中。 ',
          '《笑破天门阵》讲述的是杨宗保、穆桂英等人在天门阵遇到耶律皓南，杨家等人为破天门阵轮番上阵，最终在穆桂英的降龙木下，耶律皓南心悦诚服。整场演出幽默诙谐，令人捧腹大笑。 ',
          ' 在这里，曾拍影视作品：《古剑奇谭》《飞天舞》《仙剑奇侠传》《小李飞刀》《杨门女将》《绝代双娇》《白发魔女传》《犀利仁师》《古剑奇谭》《美人心计》《西游·降魔篇》《功夫之王》等。'
        ],
        img: [
          './images/qmsht/1.jpg',
          './images/qmsht/2.jpg',
          './images/qmsht/3.jpg',
          './images/qmsht/4.jpg',
          './images/qmsht/5.jpg',
          './images/qmsht/6.jpg',
          './images/qmsht/7.jpg',
          './images/qmsht/8.jpg',
          './images/qmsht/9.jpg',
          './images/qmsht/10.jpg',
          './images/qmsht/11.jpg',
          './images/qmsht/12.jpg',
        ]
      },
      mqgy: {
        tit: [
          '横店影视城明清宫苑简介',
          '明清宫苑这座集影视拍摄、旅游观光、节庆典礼等功能于一体的特大景区，始建于1998年，占地面积1500亩，是横店影视城目前最大的影视基地。 ',
          '明清宫苑是以“故宫”为模板1：1复制，参照了明清时期宫廷建筑手法，以影视城特有的营造方式，仿效了唐、宋、元等时期的礼制，又融入了民国年间的建筑风 格，荟萃了京城宫殿、皇家园林、王府衙门、胡同民宅等四大建筑系列，真实地再现了多个历史时期燕京的官府民居、街市店铺和宫殿风貌。拥有棋盘街、承天门广 场、千步廊、文武台、金水河、玉带桥等许多历史景观，其金碧辉煌的帝王宫殿、浑然天成的花园湖泊、富丽堂皇的龙阙凤檐、气势恢弘的皇宫广场，成为游人深宫 探幽、寻古访旧、观赏千年古都的好去处。 ',
          '明清宫苑入口处右侧的明星梦工厂专为游客拍电影 ',
          ' 《紫禁大典》——大型实景电影秀',
          '从“明成祖正旦大典”、“清乾隆万寿大典”、“新中国开国大典”三个篇章，以舞美、音乐和视频等手法演绎了明清两代封建王朝，从曾经的鼎盛景象逐渐走向衰落的历史，重新展现了新中国开国大典万众欢庆的辉煌时刻。 ',
          '《八旗马战》皇家马术特技表演 ',
          '《花车巡游》-奇幻大巡游 横店穿越秀 ',
          '萃取横店影视城各大景区拍摄的影视剧题材以及景区内演艺秀的内容，以历史时空为巡游剧情的时序主线，以露天环境下大型花车巡游为载体，以丰富的现代游乐手法为展现形式，结合多种花车机械特效装置，打造一台花车巡游盛典。 ',
          '《清宫秘戏》以《鹿鼎记》为原型，以韦小宝和建宁公主奉康熙之命闯入鳌拜府盗取四十二章经为线索而展开故事情节，采用特技摄影棚艺术，五块投影屏幕实现同步互动，利用电影特技的手段，通过三维动画与抠像合成，虚虚实实之间，将大家带入一个体验电影电视拍摄的真实环境中。 ',
          '自明清宫苑开园以来，以其别具匠心的设计风格、磅礴雄伟的艺术建筑和博大精深的文化内涵吸引着来自全国各地的游客和剧组。在此共拍摄了《天下无双》、《满城尽带黄金甲》、《金枝欲孽》、《鹿鼎记》等百余部影视大片。后宫戏大热的今天，明清宫苑更是引得剧组蜂拥而至，《延禧攻略》、《如懿传》、《宫锁心玉》、《甄嬛传》、《深宫谍影》、《宫锁珠帘》等热播剧均在此取景，随处可见明星演员拍戏工作的忙碌身影。 ',

        ],
        img: [
          './images/mqgy/1.jpg',
          './images/mqgy/2.jpg',
          './images/mqgy/3.jpg',
          './images/mqgy/4.jpg',
          './images/mqgy/5.jpg',
          './images/mqgy/6.jpg',
          './images/mqgy/7.jpg',
          './images/mqgy/8.jpg',
          './images/mqgy/9.jpg',
          './images/mqgy/10.jpg',
          './images/mqgy/11.jpg',
          './images/mqgy/12.jpg',
          './images/mqgy/13.jpg',
          './images/mqgy/14.jpg',
          './images/mqgy/15.jpg',
          './images/mqgy/16.jpg',
          './images/mqgy/17.jpg',
          './images/mqgy/18.jpg',
        ]
      },
      gzj: {
        tit: [
          '横店影视城广州街香港街简介',
          '广州街·香港街景区始建于1996年8月，为拍摄历史巨片《鸦片战争》而建，1998年9月扩建香港街影视场景，逼真的实景建筑，艺术地再现了1840年 前后的羊城旧貌和香江风韵，是中国好莱坞——横店影视城发源地。广州街·香港街景区是浙江省首批蜜月旅游首选景点，同时也是国内最有特色的婚纱摄影外景基 地之一，每年春天都有婚庆展在此举行。 ',
          '古朴的街巷点缀着“花城”，沧桑的铁轨上卧着老式火车，交错的河流汇入“珠江”，“十三夷馆”宛如万国建筑博览会，天下第一茶楼“天澜阁”则集亭台楼榭之 大全，尽显岭南建筑之精华。 ',
          '香港街整个布局利用荒野坡地优势设计，分布着皇后大道、香港总督府、维多利亚兵营、汇丰银行、上海公馆、翰园等十九世纪香港中 心城区的众多街景。这里30多座象征英国殖民统治的欧式建筑，构成了当时香港政治、经济、文化中心的“维多利亚城”，真实地再现了十九世纪香港中环维多利 亚城繁华街景。 ',
          '《怒海争风》——大型影视特技水战演艺。以鸦片战争为背景的节目，内容是说海盗走私鸦片被港警发现从而发生了激烈海战，一场警察与海盗的海上恶战，一场正义与邪恶的交战。诙谐幽默的手法表现十九世纪中叶港警与海盗激烈追逐、险象环生的大片般场景。 ',
          '《大话飞鸿》——大型影视特效情景演艺。号称“广东十虎”之一的“黄飞鸿”率领宝芝林一众人惩恶扬善，与海盗斗智斗勇，帮老百姓夺回被海盗抢去的新娘的故事。 ',
          '融汇中西的粤港风格建筑吸引了一大批谍战剧和抗战剧在此取景拍摄，在此拍摄了《鸦片战争》、《潜伏》、《百年沉浮》、《天下粮仓》等影视大片。 ',
          '在这里，曾拍摄影视剧：《鸦片战争》、《潜伏》、《归航》、《雍正王朝》、《小李飞刀》、《百年沉浮》、《天下粮仓》、《保密局的枪声》、《大陆小岛》、《奇幻冒险王》、《喋血女人花》、《新京华烟云》等数百部影视剧。',
        ],
        img: [
          './images/gzj/1.jpg',
          './images/gzj/2.jpg',
          './images/gzj/3.jpg',
          './images/gzj/4.jpg',
          './images/gzj/5.jpg',
          './images/gzj/6.jpg',
          './images/gzj/7.jpg',
          './images/gzj/8.jpg',
          './images/gzj/9.jpg',
          './images/gzj/10.jpg',
          './images/gzj/11.jpg',
          './images/gzj/12.jpg',
          './images/gzj/13.jpg',
          './images/gzj/14.jpg',
          './images/gzj/15.jpg',

        ]
      }
    };
  }

  getUrl = () => {
    return this.state.urlList.includes(this.state.urlNow) ? this.state.urlNow : false
  };


  render() {
    const jq = this.getUrl();
    const jqWord = this.state[jq].tit;
    const jqImg = this.state[jq].img;
    switch (this.getUrl()) {
      case 'mhg':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[0]}`)} alt=""/>
            <img src={require(`${jqImg[1]}`)} alt=""/>
            <img src={require(`${jqImg[2]}`)} alt=""/>
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[3]}`)} alt=""/>
            <img src={require(`${jqImg[4]}`)} alt=""/>
            <img src={require(`${jqImg[5]}`)} alt=""/>
            <p>{jqWord[4]}</p>
            <img src={require(`${jqImg[6]}`)} alt=""/>
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[7]}`)} alt=""/>
            <img src={require(`${jqImg[8]}`)} alt=""/>
            <p>{jqWord[6]}</p>
            <img src={require(`${jqImg[9]}`)} alt=""/>
            <img src={require(`${jqImg[10]}`)} alt=""/>
            <p>{jqWord[7]}</p>
            <img src={require(`${jqImg[11]}`)} alt=""/>
            <img src={require(`${jqImg[12]}`)} alt=""/>
            <p>{jqWord[8]}</p>
            <img src={require(`${jqImg[13]}`)} alt=""/>
            <img src={require(`${jqImg[14]}`)} alt=""/>
          </div>
        );
        break;
      case 'gxj':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[0]}`)} alt=""/>
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[1]}`)} alt=""/>
            <p>{jqWord[4]}</p>
            <img src={require(`${jqImg[2]}`)} alt=""/>
            <img src={require(`${jqImg[3]}`)} alt=""/>
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[4]}`)} alt=""/>
            <img src={require(`${jqImg[5]}`)} alt=""/>
            <img src={require(`${jqImg[6]}`)} alt=""/>
            <p>{jqWord[6]}</p>
            <p>{jqWord[7]}</p>
            <p>{jqWord[8]}</p>
            <p>{jqWord[9]}</p>
            <p>{jqWord[10]}</p>
            <p>{jqWord[11]}</p>
            <img src={require(`${jqImg[7]}`)} alt=""/>
            <img src={require(`${jqImg[8]}`)} alt=""/>
            <img src={require(`${jqImg[9]}`)} alt=""/>

          </div>
        );
        break;
      case 'mqg':
        return (
          <div className="App">
            <img src={require(`${jqImg[0]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[1]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[2]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[3]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[4]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[5]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[6]}`)} alt="" className={'mqgImg'}/>
            <img src={require(`${jqImg[7]}`)} alt="" className={'mqgImg'}/>

          </div>
        )
        break;
      case 'qwg':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <img src={require(`${jqImg[0]}`)} alt="" />
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[1]}`)} alt="" />
            <img src={require(`${jqImg[2]}`)} alt="" />
            <img src={require(`${jqImg[3]}`)} alt="" />
            <img src={require(`${jqImg[4]}`)} alt="" />
            <img src={require(`${jqImg[5]}`)} alt="" />
            <img src={require(`${jqImg[6]}`)} alt="" />
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[7]}`)} alt="" />
            <img src={require(`${jqImg[8]}`)} alt="" />
            <p>{jqWord[4]}</p>
            <img src={require(`${jqImg[9]}`)} alt="" />
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[10]}`)} alt="" />
            <p>{jqWord[6]}</p>
            <img src={require(`${jqImg[11]}`)} alt="" />
            <p>{jqWord[7]}</p>
            <p>{jqWord[8]}</p>
            <img src={require(`${jqImg[12]}`)} alt="" />
            <img src={require(`${jqImg[13]}`)} alt="" />
            <img src={require(`${jqImg[14]}`)} alt="" />
          </div>
        );
      break;
      case 'qmsht':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <img src={require(`${jqImg[0]}`)} alt="" />
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[1]}`)} alt="" />
            <img src={require(`${jqImg[2]}`)} alt="" />
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[3]}`)} alt="" />
            <img src={require(`${jqImg[4]}`)} alt="" />
            <img src={require(`${jqImg[5]}`)} alt="" />
            <img src={require(`${jqImg[6]}`)} alt="" />
            <img src={require(`${jqImg[7]}`)} alt="" />
            <p>{jqWord[4]}</p>
            <img src={require(`${jqImg[8]}`)} alt="" />
            <img src={require(`${jqImg[9]}`)} alt="" />
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[10]}`)} alt="" />
            <p>{jqWord[6]}</p>
            <img src={require(`${jqImg[11]}`)} alt="" />
            <p>{jqWord[7]}</p>
          </div>
        );
      break;
      case 'mqgy':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <img src={require(`${jqImg[0]}`)} alt="" />
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[1]}`)} alt="" />
            <img src={require(`${jqImg[2]}`)} alt="" />
            <img src={require(`${jqImg[3]}`)} alt="" />
            <img src={require(`${jqImg[4]}`)} alt="" />
            <img src={require(`${jqImg[5]}`)} alt="" />
            <img src={require(`${jqImg[6]}`)} alt="" />
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[7]}`)} alt="" />
            <p>{jqWord[4]}</p>
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[8]}`)} alt="" />
            <img src={require(`${jqImg[9]}`)} alt="" />
            <p>{jqWord[6]}</p>
            <img src={require(`${jqImg[10]}`)} alt="" />
            <img src={require(`${jqImg[11]}`)} alt="" />
            <p>{jqWord[7]}</p>
            <p>{jqWord[8]}</p>
            <img src={require(`${jqImg[12]}`)} alt="" />
            <img src={require(`${jqImg[13]}`)} alt="" />
            <p>{jqWord[9]}</p>
            <img src={require(`${jqImg[14]}`)} alt="" />
            <p>{jqWord[10]}</p>
            <img src={require(`${jqImg[15]}`)} alt="" />
            <img src={require(`${jqImg[16]}`)} alt="" />
            <img src={require(`${jqImg[17]}`)} alt="" />
          </div>
        )
      break;
      case 'gzj':
        return (
          <div className="App">
            <h1>{jqWord[0]}</h1>
            <p>{jqWord[1]}</p>
            <img src={require(`${jqImg[0]}`)} alt="" />
            <p>{jqWord[2]}</p>
            <img src={require(`${jqImg[1]}`)} alt="" />
            <img src={require(`${jqImg[2]}`)} alt="" />
            <img src={require(`${jqImg[3]}`)} alt="" />
            <img src={require(`${jqImg[4]}`)} alt="" />
            <img src={require(`${jqImg[5]}`)} alt="" />
            <img src={require(`${jqImg[6]}`)} alt="" />
            <p>{jqWord[3]}</p>
            <img src={require(`${jqImg[7]}`)} alt="" />
            <img src={require(`${jqImg[8]}`)} alt="" />
            <img src={require(`${jqImg[9]}`)} alt="" />
            <p>{jqWord[4]}</p>
            <img src={require(`${jqImg[10]}`)} alt="" />
            <p>{jqWord[5]}</p>
            <img src={require(`${jqImg[11]}`)} alt="" />
            <img src={require(`${jqImg[12]}`)} alt="" />
            <p>{jqWord[6]}</p>
            <p>{jqWord[7]}</p>
            <img src={require(`${jqImg[13]}`)} alt="" />
            <img src={require(`${jqImg[14]}`)} alt="" />
          </div>
        )
    }

  }
}


export default App;
